module.exports = "/assets/ac2f98e96e6576bdb2041494f19c66bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AD.png
// module id = 1191
// module chunks = 0